import {put, takeLatest, call} from 'redux-saga/effects';
import {
  loginFailure,
  loginRequest,
  loginSuccess,
  loginRequesRequestPayload,
  loginRequesSucessResponse,
  resetPasswordRequest,
  resetPasswordFailure,
  resetPasswordSuccess,
  resetPasswordRequestPayload,
  resetPasswordRequestResponse,
  verifyOTPRequest,
  verifyOTPFailure,
  verifyOTPSuccess,
  verifyOTPRequestPayload,
  verifyOTPSuccessResponse,
  resendOTPRequest,
  resendOTPFailure,
  resendOTPSuccess,
  resendOTPRequestPayload,
  resendOTPSuccessResponse,
  resetPasswordOtpRequest,
  resetPasswordOtpSuccess,
  resetPasswordOtpFailure,
  resetPasswordOtpRequestPayload,
  resetPasswordOtpSuccessResponse,
  setNewPasswordRequest,
  setNewPasswordSuccess,
  setNewPasswordFailure,
  setNewPasswordRequestPayload,
  setNewPasswordSuccessResponse,
  registerOrganizationFailure,
  registerOrganizationRequest,
  registerOrganizationSuccess,
  registerOrganizationRequestPayload,
  registerOrganizationSuccessResponse,
  resendRegisterOrganizationOTPRequest,
  resendRegisterOrganizationOTPSuccess,
  resendRegisterOrganizationOTPFailure,
  resendRegisterOrganizationOTPRequestPayload,
  resendRegisterOrganizationOTPSuccessResponse,
  verifyRegisterOrganizationOTPRequest,
  verifyRegisterOrganizationOTPFailure,
  verifyRegisterOrganizationOTPSuccess,
  verifyRegisterOrganizationOTPRequestPayload,
  verifyRegisterOrganizationOTPSuccessResponse,
} from '../slices';
import {
  signIn,
  resetPasswordOtp as resetPasswordOtpAPI,
  verifyOTP as verifyOtpAPI,
  resendOTP as resendOtpAPT,
  resetPassword as resetPasswordAPI,
  setNewPassword as setNewPasswordAPI,
  registerOrgnization as registerOrgnizationAPI,
  resendRegisterOrganizationOTP as resendRegisterOrgnizationOTPAPI,
  verifyRegisterOrganizationOTP as verifyRegisterOrgnizationOTPAPI,
} from 'services/api';
import {SUCCESS_KEY} from 'constants/keys';

/**
 * types for login request
 */
type LoginRequestAction = {
  type: typeof loginRequest.type;
  payload: loginRequesRequestPayload;
};

type LoginResponse = {
  status: string;
} & loginRequesSucessResponse;

/**
 * types for login request
 */

type ResetPasswordOtpResponse = {
  status: string;
} & resetPasswordOtpSuccessResponse;

type ResetPasswordOtpRequestAction = {
  type: typeof resetPasswordOtpRequest.type;
  payload: resetPasswordOtpRequestPayload;
};

/**
 * type for verify otp
 */

type VerifyOTPResponse = {
  status: string;
} & verifyOTPSuccessResponse;

type VerifyOTPRequestAction = {
  type: typeof verifyOTPRequest.type;
  payload: verifyOTPRequestPayload;
};

/**
 * type for resend OTP
 */

type ResendOTPResponse = {
  status: string;
} & resendOTPSuccessResponse;

type ResendOTPRequestAction = {
  type: typeof verifyOTPRequest.type;
  payload: resendOTPRequestPayload;
};

/**
 * type for reset password
 */

type ResetPasswordAction = {
  type: typeof resetPasswordRequest.type;
  payload: resetPasswordRequestPayload;
};

type ResetPasswordResponse = {
  status: string;
} & resetPasswordRequestResponse;

/**
 * type of set new password
 */

type SetNewPasswordAction = {
  type: typeof setNewPasswordRequest.type;
  payload: setNewPasswordRequestPayload;
};
type SetNewPasswordResponse = {
  status: string;
} & setNewPasswordSuccessResponse;

/**
 * type for registering orgnization
 */
type RegisterOrgnizationRequestAction = {
  type: typeof registerOrganizationRequest.type;
  payload: registerOrganizationRequestPayload;
};

type RegisterOrgnizationResponse = {
  status: string;
} & registerOrganizationSuccessResponse;


/**
 * type for registerer orgnization otp verification
 */
type VerifyRegisterOrganizationOTPAction = {
  type: typeof registerOrganizationRequest.type;
  payload: verifyRegisterOrganizationOTPRequestPayload;
};

type VerifyRegisterOrganizationOTPResponse = {
  status: string;
} & verifyRegisterOrganizationOTPSuccessResponse;


/**
 * type for registerer orgnization otp resend
 */
type ResendRegisterOrganizationOTPAction = {
  type: typeof registerOrganizationRequest.type;
  payload: resendRegisterOrganizationOTPRequestPayload;
};

type ResendRegisterOrganizationOTPResponse = {
  status: string;
} & resendRegisterOrganizationOTPSuccessResponse;



/**
 * generator function for login
 */

function* login(action: LoginRequestAction): Generator {
  try {
    const loginInfo: LoginResponse = yield call(signIn, action.payload);

    if (loginInfo.status === SUCCESS_KEY) {
      yield put(loginSuccess(loginInfo));
    } else {
      yield put(loginFailure(loginInfo.status_code));
    }
  } catch (e) {
    yield put(loginFailure('E-10001'));
  }
}

/**
 * generator function for reset password otp
 */

function* resetPasswordOtp(action: ResetPasswordOtpRequestAction): Generator {
  try {
    const response: ResetPasswordOtpResponse = yield call(
      resetPasswordOtpAPI,
      action.payload,
    );

    if (response.status === SUCCESS_KEY) {
      yield put(resetPasswordOtpSuccess(response));
    } else {
      yield put(resetPasswordOtpFailure(response.status_code));
    }
  } catch (e) {
    yield put(resetPasswordOtpFailure('E-10001'));
  }
}

function* verifyOTP(action: VerifyOTPRequestAction): Generator {
  try {
    const response: VerifyOTPResponse = yield call(
      verifyOtpAPI,
      action.payload,
    );

    if (response.status === SUCCESS_KEY) {
      yield put(verifyOTPSuccess(response));
    } else {
      yield put(verifyOTPFailure(response.status_code));
    }
  } catch (e) {
    yield put(verifyOTPFailure('E-10001'));
  }
}

function* resendOTP(action: ResendOTPRequestAction): Generator {
  try {
    const response: ResendOTPResponse = yield call(
      resendOtpAPT,
      action.payload,
    );

    if (response.status === SUCCESS_KEY) {
      yield put(resendOTPSuccess(response));
    } else {
      yield put(resendOTPFailure(response.status_code));
    }
  } catch (e) {
    yield put(resendOTPFailure('E-10001'));
  }
}

/**
 * saga function for reset password
 */

function* resetPassword(action: ResetPasswordAction): Generator {
  try {
    const response: ResetPasswordResponse = yield call(
      resetPasswordAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(resetPasswordSuccess(response.status_code));
    } else {
      yield put(resetPasswordFailure(response.status_code));
    }
  } catch (e) {
    yield put(resetPasswordFailure('E-10001'));
  }
}

/**
 * saga function for set new password
 */
function* setNewPassword(action: SetNewPasswordAction): Generator {
  try {
    const response: SetNewPasswordResponse = yield call(
      setNewPasswordAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(setNewPasswordSuccess(response.status_code));
    } else {
      yield put(setNewPasswordFailure(response.status_code));
    }
  } catch (e) {
    yield put(setNewPasswordFailure('E-10001'));
  }
}

/**
 * saga function for registering a new organization
 */
function* registerOrg(action: RegisterOrgnizationRequestAction): Generator {
  try {
    const response: RegisterOrgnizationResponse = yield call(
      registerOrgnizationAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(registerOrganizationSuccess(response));
    } else {
      yield put(registerOrganizationFailure(response.status_code));
    }
  } catch (e) {
    yield put(registerOrganizationFailure('E-10001'));
  }
}

function* verifyRegisterOrganizationOTP(action: VerifyRegisterOrganizationOTPAction): Generator {
  try {
    const response: VerifyRegisterOrganizationOTPResponse = yield call(
      verifyRegisterOrgnizationOTPAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(verifyRegisterOrganizationOTPSuccess(response));
    } else {
      yield put(verifyRegisterOrganizationOTPFailure(response.status_code));
    }
  } catch (e) {
    yield put(verifyRegisterOrganizationOTPFailure('E-10001'));
  }
}

function* resendRegisterOrganizationOTP(action: ResendRegisterOrganizationOTPAction): Generator {

  try {
    const response: ResendRegisterOrganizationOTPResponse = yield call(
      resendRegisterOrgnizationOTPAPI,
      action.payload,
    );

    if (response.status === SUCCESS_KEY) {
      yield put(resendRegisterOrganizationOTPSuccess(response));
    } else {
      yield put(resendRegisterOrganizationOTPFailure(response.status_code));
    }
  } catch (e) {
    yield put(resendRegisterOrganizationOTPFailure('E-10001'));
  }
}

export function* authSaga() {
  yield takeLatest(loginRequest.type, login);
  yield takeLatest(resetPasswordOtpRequest.type, resetPasswordOtp);
  yield takeLatest(verifyOTPRequest.type, verifyOTP);
  yield takeLatest(resendOTPRequest.type, resendOTP);
  yield takeLatest(resetPasswordRequest.type, resetPassword);
  yield takeLatest(setNewPasswordRequest.type, setNewPassword);
  yield takeLatest(registerOrganizationRequest.type, registerOrg);
  yield takeLatest(resendRegisterOrganizationOTPRequest.type, resendRegisterOrganizationOTP);
  yield takeLatest(verifyRegisterOrganizationOTPRequest.type, verifyRegisterOrganizationOTP);
}
